/**
 * @generated SignedSource<<95f9476ba6f9b974dc14486e1eb8afc0>>
 * @relayHash 57057313f17699c6ffabb286b9a1141a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceAppInstallationLicenseCapabilitySet = "CAPABILITY_ADVANCED" | "CAPABILITY_STANDARD" | "%future added value";
export type ConfluenceExtensionVisibilityControlMechanism = "APP_ACCESS_RULES" | "DISPLAY_CONDITIONS" | "%future added value";
export type ConfluenceExtensionRenderingContextInput = {
  contentId?: AGG$Long | null | undefined;
  spaceId?: AGG$Long | null | undefined;
  spaceKey?: string | null | undefined;
};
export type usePrefilteredExtensionList_forge_ui_Query$variables = {
  cloudId: string;
  context?: ConfluenceExtensionRenderingContextInput | null | undefined;
  includeHidden?: boolean | null | undefined;
  locale?: string | null | undefined;
  types?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type usePrefilteredExtensionList_forge_ui_Query$data = {
  readonly confluence_forgeExtensionsByType: ReadonlyArray<{
    readonly appId: string;
    readonly appOwner: string | null | undefined;
    readonly appVersion: string | null | undefined;
    readonly consentUrl: string | null | undefined;
    readonly egress: ReadonlyArray<{
      readonly addresses: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly category: string | null | undefined;
      readonly inScopeEUD: boolean | null | undefined;
      readonly type: string | null | undefined;
    }> | null | undefined;
    readonly environmentId: string;
    readonly environmentKey: string | null | undefined;
    readonly environmentType: string;
    readonly hiddenBy: ConfluenceExtensionVisibilityControlMechanism | null | undefined;
    readonly id: string;
    readonly installationId: string;
    readonly key: string;
    readonly license: {
      readonly active: boolean;
      readonly billingPeriod: string | null | undefined;
      readonly capabilitySet: ConfluenceAppInstallationLicenseCapabilitySet | null | undefined;
      readonly ccpEntitlementId: string | null | undefined;
      readonly ccpEntitlementSlug: string | null | undefined;
      readonly isEvaluation: boolean | null | undefined;
      readonly subscriptionEndDate: string | null | undefined;
      readonly trialEndDate: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly migrationKey: string | null | undefined;
    readonly properties: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    }>;
    readonly scopes: ReadonlyArray<string | null | undefined>;
    readonly type: string;
    readonly userAccess: {
      readonly enabled: boolean | null | undefined;
      readonly hasAccess: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type usePrefilteredExtensionList_forge_ui_Query = {
  response: usePrefilteredExtensionList_forge_ui_Query$data;
  variables: usePrefilteredExtensionList_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeHidden"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "types"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "key"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "includeHidden",
        "variableName": "includeHidden"
      },
      {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
      },
      {
        "kind": "Variable",
        "name": "types",
        "variableName": "types"
      }
    ],
    "concreteType": "ConfluenceForgeExtension",
    "kind": "LinkedField",
    "name": "confluence_forgeExtensionsByType",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "appId"
      },
      {
        "kind": "ScalarField",
        "name": "appVersion"
      },
      {
        "kind": "ScalarField",
        "name": "appOwner"
      },
      {
        "kind": "ScalarField",
        "name": "environmentId"
      },
      {
        "kind": "ScalarField",
        "name": "environmentType"
      },
      {
        "kind": "ScalarField",
        "name": "environmentKey"
      },
      {
        "kind": "ScalarField",
        "name": "consentUrl"
      },
      {
        "kind": "ScalarField",
        "name": "migrationKey"
      },
      {
        "concreteType": "ConfluenceUserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "enabled"
          },
          {
            "kind": "ScalarField",
            "name": "hasAccess"
          }
        ]
      },
      (v1/*: any*/),
      {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      },
      {
        "concreteType": "ConfluenceExtensionEgressDeclaration",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "addresses"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "inScopeEUD"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "scopes"
      },
      {
        "concreteType": "ConfluenceAppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          },
          {
            "kind": "ScalarField",
            "name": "capabilitySet"
          },
          {
            "kind": "ScalarField",
            "name": "billingPeriod"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementId"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementSlug"
          },
          {
            "kind": "ScalarField",
            "name": "isEvaluation"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionEndDate"
          },
          {
            "kind": "ScalarField",
            "name": "trialEndDate"
          },
          (v2/*: any*/)
        ]
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "installationId"
      },
      {
        "kind": "ScalarField",
        "name": "hiddenBy"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b",
    "metadata": {},
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d028e6b4d01b71cf67c24b6983fbfddf";

export default node;
